import { CodeSmall } from '@wix/wix-ui-icons-common';

import type { EditorPlugin, EditorPluginCreator } from './../ricos-types';
import { createShortcut, Node_Type, quickActionsModalSections } from './../ricos-types';

import { codeBlockConverter } from './code-block-converter';
import { DEFAULTS } from './defaults';
import { getAddButtons } from './getAddButtons';
import { getTextButtons } from './getTextButtons';
import { tiptapExtensions } from './tiptap';
import type { CodeBlockPluginEditorConfig } from './types';
import { CODE_BLOCK_TYPE } from './types';

export const pluginCodeBlock: EditorPluginCreator<CodeBlockPluginEditorConfig> = config => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: CODE_BLOCK_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [codeBlockConverter],
    shortcuts: [
      createShortcut({
        name: Node_Type.CODE_BLOCK,
        description: 'ShortcutsSheet_Formatting_CodeBlock',
        keys: { macOs: 'Meta+Shift+C', windows: 'Ctrl+Shift+C' },
        command({ publicCommands }) {
          publicCommands.setBlockType(CODE_BLOCK_TYPE);
        },
        group: 'ShortcutsSheet_Section_Formatting',
        enabled: true,
      }),
    ],
    getAddButtons: (config, services) => getAddButtons(config, services),
    tiptapExtensions,
    textButtons: getTextButtons(),
    getQuickActions: () => [
      {
        id: 'codeSnippet',
        title: 'QuickActionsPlugin_ActionTitle_CodeSnippet',
        icon: CodeSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ['programming', 'code block', 'script', 'developer', 'code section', 'syntax'],
        command: ({ publicCommands }) => publicCommands.setBlockType(CODE_BLOCK_TYPE),
      },
    ],
  } as EditorPlugin;
};
